var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content-header"},[_c('h1',{class:{ fade: _vm.isChanging }},[_vm._v(_vm._s(_vm.pageTitle))])]),_c('div',{staticClass:"security-content"},[_c('div',{staticClass:"image-container"},[_c('PadlockIcon')],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('span',[_vm._v("Compra")]),_c('span',[_vm._v("Segura")])])
}]

export { render, staticRenderFns }